import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { limitCustomersSelect } from 'utils/common';

import { Button } from '@p81-common/ui';

import classes from './ButtonsContainer.module.scss';

const ButtonsContainer = ({
  counter,
  handleCancel,
  handleOpenModal,
  handleOnAdditionalButtonClick,
  additionalButtonDisabled,
  btnCancel = true,
  btnOpen = true,
  btnAdditional = true,
  btnEnable = counter > limitCustomersSelect - 1,
  action,
  additionalButtonText,
  classesBtn
}) => {
  return (
    <div>
      {btnCancel && (
        <Button
          color="secondary"
          className={cn(
            classes.button,
            classes.button_cancel,
            classesBtn && classesBtn.cancel
          )}
          onClick={handleCancel}
        >
          Cancel
        </Button>
      )}
      {btnOpen && (
        <Button
          disabled={btnEnable}
          className={classes.button_version}
          onClick={handleOpenModal}
        >
          {action}
        </Button>
      )}

      {btnAdditional && handleOnAdditionalButtonClick && additionalButtonText && (
        <Button
          className={classes.button_version}
          onClick={handleOnAdditionalButtonClick}
          disabled={additionalButtonDisabled}
        >
          {additionalButtonText}
        </Button>
      )}
    </div>
  );
};

ButtonsContainer.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleOpenModal: PropTypes.func.isRequired,
  handleOnAdditionalButtonClick: PropTypes.func,
  additionalButtonText: PropTypes.string,
  additionalButtonDisabled: PropTypes.bool,
  btnCancel: PropTypes.bool,
  btnOpen: PropTypes.bool,
  btnAdditional: PropTypes.bool,
  btnEnable: PropTypes.bool,
  action: PropTypes.string,
  classesBtn: PropTypes.object,
  counter: PropTypes.number
};

export default ButtonsContainer;
